import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Modal from '@material-ui/core/Modal'
import Grid from '@material-ui/core/Grid'

import Progress from '../Common/Progress'
import { commonActions } from '../../_actions'

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  paper: {
    position: 'absolute',
    width: '90%',
    maxHeight: '80%',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: '90%',
      overflow: 'scroll'
    },
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4
  },
  textField: {
    width: '90%',
    margin: theme.spacing.unit
  },
  margin: {
    margin: theme.spacing.unit
  },
  formControl: {
    width: '25vh',
    marginLeft: '20px'
  }
})

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  }
}

class CommonFormComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mode: 'ADD',
      modalTitle: '新增成本單位',
      dynamicFormData: [],
      addMoreBtn: true,
      selectedCommonType: '',
      openProgress: false
    }

    this.handleAddShareholder = this.handleAddShareholder.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedCommonType: nextProps.selectedCommonType
    })

    if (nextProps.commonData && nextProps.commonData !== undefined) {
      this.setState({
        dynamicFormData: [
          {
            CommonId: nextProps.commonData.CommonId,
            DefineId: nextProps.commonData.DefineId,
            CommonType: nextProps.commonData.CommonType
              ? nextProps.commonData.CommonType
              : '',
            CommonValue1: nextProps.commonData.CostUnitId
              ? nextProps.commonData.CostUnitId
              : '',
            CommonValue2: nextProps.commonData.DefineValue2
              ? nextProps.commonData.DefineValue2
              : '',
            CommonValue3: nextProps.commonData.DefineValue3
              ? nextProps.commonData.DefineValue3
              : '',
            CommonLocate: nextProps.commonData.CommonLocate
              ? nextProps.commonData.CommonLocate
              : ''
          }
        ],
        addMoreBtn: false,
        mode: 'EDIT',
        modalTitle: '修改成本單位'
      })
    } else {
      this.setState({
        mode: 'ADD',
        modalTitle: '新增成本單位',
        dynamicFormData: [],
        addMoreBtn: true
      })
    }
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handleClose = () => {
    this.cleanData()
    this.props.close()
  }

  cleanData() {
    this.setState({
      openProgress: false,
      mode: '',
      dynamicFormData: [],
      addMoreBtn: true
    })
  }

  handleAddShareholder = () => {
    this.setState({
      dynamicFormData: this.state.dynamicFormData.concat([
        {
          CommonStatus: 'A',
          CommonType: this.state.selectedCommonType,
          CommonValue1: '',
          CommonValue2: '',
          CommonValue3: '',
          CommonLocate: 'TW',
          CreatedUserId: this.props.user.id
        }
      ])
    })
  }

  handleRemoveShareholder = idx => () => {
    this.setState({
      dynamicFormData: this.state.dynamicFormData.filter(
        (s, sidx) => idx !== sidx
      )
    })
  }

  handleDynamicDataChange = idx => evt => {
    const newShareholders = this.state.dynamicFormData.map(
      (shareholder, sidx) => {
        if (idx !== sidx) return shareholder
        return { ...shareholder, [evt.target.id]: evt.target.value }
      }
    )

    this.setState({
      dynamicFormData: newShareholders
    })
  }

  handleSave = () => {
    const DataProcessing = async () => {
      try {
        this.setState({
          openProgress: true
        })

        if (this.state.mode === 'ADD') {
          await this.props.dispatch(
            commonActions.insert(this.state.dynamicFormData)
          )
        } else if (this.state.mode === 'EDIT') {
          let dynamicFormData = this.state.dynamicFormData[0]
          await this.props.dispatch(commonActions.update(dynamicFormData))
        }

        await this.handleClose()
        await this.props.dispatch(
          commonActions.getAll(this.state.selectedCommonType)
        )
      } catch (e) {
        console.error('Problem', e)
      }
    }

    if (this.state.mode === 'ADD' || this.state.mode === 'EDIT') {
      DataProcessing()
    }
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <Progress openProgress={this.state.openProgress} />
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.props.open}
          onClose={this.handleClose}>
          <div style={getModalStyle()} className={classes.paper}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Typography id="modal-title" style={{ fontSize: 40 }}>
                {this.state.modalTitle}
              </Typography>
            </div>

            {this.state.dynamicFormData.map((shareholder, idx) => (
              <Grid key={idx} container>
                <Grid item xs={6} sm={6} md={2}>
                  <TextField
                    disabled
                    label="Type"
                    id="CommonType"
                    fullWidth
                    className={classes.textField}
                    onChange={this.handleDynamicDataChange(idx)}
                    value={shareholder.CommonType}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <TextField
                    label="成本單位編號"
                    id="CommonValue1"
                    fullWidth
                    className={classes.textField}
                    onChange={this.handleDynamicDataChange(idx)}
                    value={shareholder.CommonValue1}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <TextField
                    label="成本單位命名"
                    id="CommonValue2"
                    fullWidth
                    className={classes.textField}
                    onChange={this.handleDynamicDataChange(idx)}
                    value={shareholder.CommonValue2}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <TextField
                    label="成本單位區域"
                    id="CommonLocate"
                    fullWidth
                    className={classes.textField}
                    onChange={this.handleDynamicDataChange(idx)}
                    value={shareholder.CommonLocate}
                  />
                </Grid>
                {this.state.addMoreBtn ? (
                  <Grid item xs={6} sm={6} md={1}>
                    <Button
                      color="secondary"
                      variant="outlined"
                      className={classes.buttonInside}
                      onClick={this.handleRemoveShareholder(idx)}>
                      -
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
            ))}

            {this.state.addMoreBtn ? (
              <Button
                variant="outlined"
                className={classes.button}
                onClick={this.handleAddShareholder}>
                Add More
              </Button>
            ) : null}

            <div style={{ marginTop: '40px' }} />
            <Button
              color="secondary"
              variant="outlined"
              className={classes.button}
              onClick={this.handleSave}>
              Save
            </Button>
            <Button
              variant="outlined"
              className={classes.button}
              onClick={this.handleClose}>
              Cancel
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication
  const { users, departments, common } = state

  return {
    user,
    users,
    departments,
    common
  }
}

CommonFormComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(CommonFormComponent)



// WEBPACK FOOTER //
// ./src/components/Settings/CostUnitFormComponentTW.js